












import { Component, Vue } from 'vue-property-decorator';
import BoxTile from '@/components/ui/BoxTile.vue';
import TextContent from '@/components/ui/TextContent.vue';
import {SET_LAYOUT_CONFIG} from '@/store/layout_module';

@Component({
  components: {
    TextContent,
    BoxTile
  },
})
export default class GoalsPast extends Vue {

  get latestGoal() {
    if (this.$store.state.data) {
      if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
        return this.$store.state.data.goals[0].goalKey
      }
      return 'latest';
    }
    return 'latest';
  }

  get goals() {
    return this.$store.state.data.goals.filter((goal: any, index: number) => index !== 0);
  }

  public goalTitle( goal: any ) {
    if (goal.months_range) return this.$tc('GOAL.PAST.MONTHS', goal.months_range)
    return this.$t('GOAL.PAST.WEEKS', {weeks:goal.weeks_range})
  }

  public updatePageTitle() {
    this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
      showPageTitle: true,
      showBackButton: true,
      pageTitle: 'GOAL.PAST.PAGE_TITLE',
      pageTitleParams: null,
      backButtonLink: {name: 'dashboard.goals.goal', params: {id: this.latestGoal}},
      showFooterNav: true
    })
  }

  private updated() {
    this.updatePageTitle();
  }

  private mounted() {
    this.updatePageTitle();
  }

}
